"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    assertPortraitMessage: 'לצפייה מיטבית יש לסובב את המסך לגובה',
    assertLandscapeMessage: 'לצפייה מיטבית יש לסובב את המסך לרוחב'
  },
  ar: {
    assertPortraitMessage: 'للحصول على عرض مثالي، اقلب الشاشة إلى الوضع الرأسي',
    assertLandscapeMessage: 'للمشاهدة الأمثل اقلبوا الشاشة إلى الوضعيّة الأفقيّة'
  },
  en: {
    assertPortraitMessage: 'For optimal viewing, turn your device to a vertical position',
    assertLandscapeMessage: 'For optimal viewing, turn your device to a horizontal position'
  }
};